import { useSelector } from 'react-redux';
import { projectPickerSelectors } from '../redux/modules/projectPicker';

export const useActiveProjectId = (): string =>
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  useSelector(projectPickerSelectors.selectActiveProjectId);

export default useActiveProjectId;
